import { AllowedComponentType, BlockType, ComponentSettings, ComponentsType, DatasetField } from '@report-content';
import { AbstractBlockFactory } from './AbstractBlockFactory';
import { BlockFactoryBubbleChart } from '../cmp/bubble-chart';
import { BlockFactoryKpiChart } from '../cmp/kpi-chart';
import { BlockFactoryManageFilters } from '../cmp/manage-filters';
import { BlockFactoryDataset } from '../cmp/dataset';
import { BlockFactoryPivot } from '../cmp/pivot';
import { BlockFactoryPieChart } from '../cmp/pie-chart';
import { BlockFactoryExternalVisualization } from '../cmp/external-visualization';
import { BlockFactoryFunnelChart } from '../cmp/funnel-chart';
import { BlockFactoryLineChart } from '../cmp/line-chart';
import { BlockFactoryMapChart } from '../cmp/map-chart';
import { BlockFactoryRangeChart } from '../cmp/range-chart';
import { BlockFactoryJct } from '../cmp/jct';
import { BlockFactoryTextBlock } from '../cmp/text-block';
import { BlockFactoryLlm } from '../cmp/llm';

export interface NewBlockContextType {
    datasetFields: Array<DatasetField>;
    nextSortOrder: number;
    nextUId: number;
}
const AllowedFactories: {
    [key in ComponentsType]: typeof AbstractBlockFactory<ComponentSettings>;
} = {
    bubble_chart: BlockFactoryBubbleChart,
    dataset: BlockFactoryDataset,
    chart: BlockFactoryPieChart,
    external_visualization: BlockFactoryExternalVisualization,
    funnel_chart: BlockFactoryFunnelChart,
    jct: BlockFactoryJct,
    kpi: AbstractBlockFactory, //TODO
    kpi_chart: BlockFactoryKpiChart,
    line: BlockFactoryLineChart,
    map_chart: BlockFactoryMapChart,
    pivot: BlockFactoryPivot,
    range_chart: BlockFactoryRangeChart,
    text_block: BlockFactoryTextBlock,
    manage_filters: BlockFactoryManageFilters,
    llm: BlockFactoryLlm,
};

export class BlockFactory {
    public static getNewBlock(
        component: AllowedComponentType,
        blockContextProps: NewBlockContextType,
    ): BlockType<ComponentSettings> {
        // Exception for Jct
        const jct = component.internalName.match(/jct_([0-9]+)/);
        if (jct) {
            const factoryClass = new AllowedFactories['jct']();
            return (factoryClass as BlockFactoryJct).getNewBlock({
                ...blockContextProps,
                jctId: Number(jct[1]),
                name: component.name,
                properties: component?.properties ?? {},
            });
        }

        const factoryClass = new AllowedFactories[component.internalName]();
        return factoryClass.getNewBlock(blockContextProps);
    }
}
